(function () {
"use strict";

// === Config ===
const EFX_MIN_LEN    = 2;
const EFX_TYPES      = "product";
const EFX_LIMIT      = 20;   // slider için üst limit
const EFX_LIMIT_SEARCH = 12; // yazarken getirilecek item sayısı
const EFX_SLIDE_SIZE = 4;    // her sayfada 4 kart
const RECENT_KEY = "efx_recent_searches";
const RECENT_MAX = 10;

// Spinner/empty/error stilleri efx-search.css icinde.

// --- Metinler ---
const EFX_TXT_EMPTY_TITLE = "Aradığınız kriterlere uygun ürün bulunamadı";
const EFX_TXT_EMPTY_SUB   = "Farklı bir kelime deneyebilir veya yazımı kontrol edebilirsiniz.";
const EFX_TXT_ERROR       = "Sonuçlar yüklenemedi. Lütfen tekrar deneyin.";

// --- Search state ---
let inSearchMode = false;
let lastSearchResults = null; // son arama (predictive+search) ürün listesi
let efxSearchReqId = 0;
let efxPopularReqId = 0;      // popüler/vendor yüklemeleri için yarış koruması
let efxCurrentQuery = "";     // son aranan metin (geçmiş aramalara yazmak için)

let dbVendors = [];

//=== Proxy ===
async function sendDataToProxy(payload) {
  try {
    const response = await fetch('/apps/efx-mila', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const ct = response.headers.get('content-type') || '';
    const raw = await response.text(); // önce ham metni al

    if (!response.ok) {
      throw new Error(`HTTP ${response.status} ${response.statusText}`);
    }

    // JSON ise parse et; değilse metni geri dön
    const result = ct.includes('application/json')
      ? JSON.parse(raw)
      : raw;

    return result;
  } catch (err) {
    console.error('[proxy] parse/req error:', err);
    return undefined;
  }
}

/* Marka listesi (app proxy).
   ──────────────────────────────────────────────────────────────────
   Bu istek her sayfa yüklenişinde çıkıyordu; liste neredeyse hiç değişmiyor.
   sessionStorage ile sekme başına bir kez çekiyoruz. TTL, uzun süre açık
   kalan sekmelerde listenin bayatlamaması için.

   Liste geç gelirse (ilk yükleme) renderVendorList filtreyi uygulayamıyor ve
   pasif markalar arama sonucunda görünüyordu; geldiğinde açık olan sonucun
   marka şeridini bir kez tazeliyoruz. */
const EFX_VENDORS_KEY = "efx_db_vendors";
const EFX_VENDORS_TTL = 6 * 60 * 60 * 1000; // 6 saat

function efxReadVendorCache() {
  try {
    const raw = sessionStorage.getItem(EFX_VENDORS_KEY);
    if (!raw) return null;
    const obj = JSON.parse(raw);
    if (!obj || !Array.isArray(obj.vendors)) return null;
    if (Date.now() - obj.ts > EFX_VENDORS_TTL) {
      sessionStorage.removeItem(EFX_VENDORS_KEY);
      return null;
    }
    return obj.vendors;
  } catch { return null; }
}
function efxWriteVendorCache(vendors) {
  try {
    sessionStorage.setItem(EFX_VENDORS_KEY, JSON.stringify({ ts: Date.now(), vendors }));
  } catch {}
}
// Liste sonradan geldiyse ekrandaki marka şeridini yeniden çiz.
function efxOnVendorsReady() {
  if (!inSearchMode || !$results || $results.hidden) return;
  if (!Array.isArray(lastSearchResults) || !lastSearchResults.length) return;
  const uniq = Array.from(new Set(lastSearchResults.map(it => it.vendor).filter(Boolean)));
  renderVendorList(uniq, efxCurrentQuery);
}

const efxCachedVendors = efxReadVendorCache();
if (efxCachedVendors) {
  dbVendors = efxCachedVendors;
} else {
  sendDataToProxy({ action: 'getVendors' }).then((res) => {
    if (res?.ok && Array.isArray(res.vendors)) {
      dbVendors = res.vendors;
      efxWriteVendorCache(res.vendors);
      efxOnVendorsReady();
    } else {
      console.error("Backend error:", res?.error || res);
    }
  });
}



// === Abort / Timeout / Cache ===
let efxCtrl = { pred: null, search: null };
function efxCancelInFlight() {
  try { efxCtrl.pred?.abort(); } catch {}
  try { efxCtrl.search?.abort(); } catch {}
  efxCtrl.pred = null;
  efxCtrl.search = null;
}

// timeout + harici signal birleşik (AbortSignal.any yoksa fallback)
async function efxFetchWithTimeout(input, init = {}, ms = 8000) {
  const timeoutCtrl = new AbortController();
  const baseInit = { ...init };
  const signals = [timeoutCtrl.signal];
  if (init.signal) signals.push(init.signal);

  let signalToUse;
  if (typeof AbortSignal !== "undefined" && AbortSignal.any) {
    signalToUse = AbortSignal.any(signals);
  } else if (signals.length > 1) {
    const combo = new AbortController();
    const abortOnce = (reason) => { try { combo.abort(reason || "aborted"); } catch {} };
    signals.forEach(s => s.addEventListener("abort", () => abortOnce(s.reason), { once: true }));
    signalToUse = combo.signal;
  } else {
    signalToUse = signals[0];
  }

  const id = setTimeout(() => { try { timeoutCtrl.abort("timeout"); } catch {} }, ms);
  try {
    delete baseInit.signal; // birleşik signal kullanılacak
    return await fetch(input, { ...baseInit, signal: signalToUse });
  } finally {
    clearTimeout(id);
  }
}

const efxCache = new Map(); // key -> {ts, data}
function efxGetCache(key, maxAgeMs = 45000) {
  const hit = efxCache.get(key);
  if (!hit) return null;
  if (Date.now() - hit.ts > maxAgeMs) { efxCache.delete(key); return null; }
  return hit.data;
}
function efxSetCache(key, data) { efxCache.set(key, { ts: Date.now(), data }); }

// === Helpers ===
const efxIsCoarse = () =>
  (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) ||
  ('ontouchstart' in window);

function efxFindDbVendor(name) {
  if (!name || !Array.isArray(dbVendors) || dbVendors.length === 0) return null;
  const key = String(name).trim().toLowerCase();
  return dbVendors.find(v =>
    String(v.name || v.vendor || "").trim().toLowerCase() === key
  ) || null;
}
function efxIsVendorActive(vendorRow) {
  const st = vendorRow?.status;
  if (st === undefined || st === null || st === "") return true;
  const n = Number(st);
  return Number.isNaN(n) ? Boolean(st) : n !== 0;
}
function efxIsRootCollections(u) {
  if (!u) return true;
  try {
    const url = new URL(u, location.origin);
    const p = url.pathname.replace(/\/+/g, '/');
    return /^\/collections\/?$/.test(p);
  } catch {
    const s = String(u).trim().replace(/\/+/g, '/');
    return s === 'collections' || s === '/collections' || s === '/collections/';
  }
}
function efxIsMalformedCollectionUrl(u) {
  if (!u) return true;
  const s = String(u).trim();
  const httpCount = (s.match(/https?:\/\//gi) || []).length;
  if (httpCount > 1) return true;
  if (/\/collections\/https?:\/\//i.test(s)) return true;
  if (efxIsRootCollections(s)) return true;
  try {
    const url = new URL(s, location.origin);
    const p = url.pathname.replace(/\/+/g, '/');
    if (!/^\/collections\/[^\/?#]+\/?$/.test(p)) return true;
    const slug = p.split('/').filter(Boolean)[1] || '';
    if (/^https?:/i.test(slug)) return true;
  } catch {
    const norm = s.replace(/\/+/g, '/');
    if (norm.startsWith('/collections/')) {
      const tail = norm.replace(/^\/collections\//, '');
      if (!tail || /https?:\/\//i.test(tail)) return true;
    }
  }
  return false;
}
function efxNormalizeCollectionUrl(urlOrHandle) {
  if (!urlOrHandle) return null;
  const u = String(urlOrHandle).trim();
  let candidate = (/^https?:\/\//i.test(u) || u.startsWith('/collections/'))
    ? u
    : `/collections/${u}`;
  if (efxIsMalformedCollectionUrl(candidate)) return null;
  return candidate;
}
function efxGetVendorCollectionUrl(vendorName) {
  const row = efxFindDbVendor(vendorName);
  if (!row) return null;
  if (!efxIsVendorActive(row)) return null;
  const normalized = efxNormalizeCollectionUrl(row.url);
  return normalized || null;
}
function efxVendorSearchHref(query, vendorName) {
  let href = `/search?q=${encodeURIComponent(query)}&filter.v.availability=1&sort_by=relevance`;
  if (vendorName) href += `&filter.p.vendor=${encodeURIComponent(vendorName)}`;
  return href;
}
const efxBounce = (fn, wait = 220) => {
  let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), wait); };
};
function efxChunk(arr, size) {
  const out = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
}
// Ürün başlığı/markası mağazadan geliyor ama yine de metin olarak basılmalı:
// tırnak içeren bir başlık markup'ı bozuyordu.
function efxEsc(v) {
  return String(v == null ? "" : v)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
function efxHoverIntent(el, onIntent, onLeave, delay = 120) {
  let t = null;
  el.addEventListener("mouseenter", () => {
    t = setTimeout(() => { onIntent && onIntent(); }, delay);
  });
  el.addEventListener("mouseleave", () => {
    if (t) { clearTimeout(t); t = null; }
    onLeave && onLeave();
  });
}
function efxUpdateSidebarVisibility() {
  if (!$results) return;
  const isNarrow = window.innerWidth < 1200;
  document.querySelectorAll(".efx-search-overlay .efx-sidebar").forEach((sb) => {
    const inResults = sb.closest(".efx-search-results") !== null && !$results.hidden;
    const shouldHide = isNarrow && inSearchMode && inResults;
    sb.style.display = shouldHide ? "none" : "";
  });
}
// Grid'i yeni bir duruma geçirmeden önce önceki turun wishlist bekleyicisini
// kapat: kartlar DOM'dan koptuğu için o bekleyici asla "hazır" göremez ve
// 700 ms sonra artık var olmayan düğümler üzerinde uyanırdı.
function efxResetGridState(mount) {
  if (!mount) return;
  if (mount.__efxWishlistIptal) mount.__efxWishlistIptal();
  mount.classList.remove("efx-cards-pending");
}
function efxSpinnerHTML(ekSinif){
  return `<div class="efx-loading${ekSinif ? " " + ekSinif : ""}"><div class="efx-spinner" role="status" aria-label="Yükleniyor"></div></div>`;
}
// Grid'de tek başına spinner mı duruyor?
function efxSpinnerDonuyorMu(mount){
  return !!(mount && mount.children.length === 1 &&
            mount.firstElementChild.classList.contains("efx-loading"));
}

/* Dönen bir spinner varsa ona DOKUNMA.
   ──────────────────────────────────────────────────────────────────
   Tek bir aramada burası iki kez çağrılıyor: önce onTypeImmediate (tuşa
   basar basmaz, debounce'suz), sonra debounce'lu efxLoadPopularSearch.
   innerHTML'i yeniden yazmak yeni bir DÜĞÜM yaratıyor ve CSS animasyonu
   sıfırdan başlıyor. Tarayıcıda ölçüldü: ikinci düğümün animasyon saati 0,
   yani halka görünür şekilde başa sarıyor. Kullanıcının gördüğü şey bu —
   "spinner iki kez tetikleniyor".

   Dönüş değeri: true  -> yeni basıldı, çağıran boyamayı beklemeli
                 false -> zaten dönüyordu, beklemeye gerek yok. */
function efxShowSpinner(mount){
  if(!mount) return false;
  if (efxSpinnerDonuyorMu(mount)) return false;

  // Spinner var ama yanında başka şeyler de var (ör. kalp bekleyen kartlar):
  // düğümü koru, komşularını temizle. Yine sıfırlama yok.
  const mevcut = mount.querySelector(":scope > .efx-loading");
  efxResetGridState(mount);
  if (mevcut) {
    mevcut.classList.remove("efx-cards-wait");
    Array.from(mount.children).forEach(ch => { if (ch !== mevcut) ch.remove(); });
    return false;
  }

  mount.innerHTML = efxSpinnerHTML();
  return true;
}
// Sonuç yok: slider'ı (dolayısıyla oklarını) hiç kurmayıp yerine metin basıyoruz.
function efxShowEmpty(mount, title, sub){
  if(!mount) return;
  efxResetGridState(mount);
  mount.innerHTML = `
    <div class="efx-empty" role="status">
      <svg class="efx-empty-icon" viewBox="0 0 24 24" width="34" height="34" fill="none"
           stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="11" cy="11" r="7"></circle><path d="m21 21-4.3-4.3"></path>
      </svg>
      <div class="efx-empty-title">${efxEsc(title || EFX_TXT_EMPTY_TITLE)}</div>
      <div class="efx-empty-sub">${efxEsc(sub == null ? EFX_TXT_EMPTY_SUB : sub)}</div>
    </div>`;
}
function efxShowError(mount, msg){
  if(!mount) return;
  efxResetGridState(mount);
  mount.innerHTML = `<div class="efx-error" role="alert">${efxEsc(msg || EFX_TXT_ERROR)}</div>`;
}

// Boyamaya izin ver (2 rAF: bazı Chrome sürümlerinde daha garantili)
async function efxNextPaint() {
  await new Promise(r => requestAnimationFrame(r));
  await new Promise(r => requestAnimationFrame(r));
}

// Sonuç kabuğunu hazırlayıp grid'i döndür
function efxEnsureResultsShell() {
  $default.hidden = true;
  $results.hidden = false;
  if (!$results.__shell) {
    $results.innerHTML = `
      <div class="efx-upper-bar">
        <div class="efx-vendors-bar">
          <h4 style="margin-bottom:0;">Markalar</h4>
          <ul class="efx-pop-vendors"></ul>
        </div>
        <div style="display:flex;">
          <button type="button" class="efx-popUp-close" aria-label="Kapat">✖</button>
        </div>
      </div>
      <div class="efx-cols">
        <aside class="efx-sidebar">
          <h4>Arama</h4>
          <div class="efx-query"></div>
        </aside>
        <section class="efx-main">
          <div class="efx-section-head">
            <div class="efx-section-title">Ürünler</div>
            <a class="efx-see-all-top" href="#" hidden>Tümünü Gör <span aria-hidden="true">→</span></a>
          </div>
          <div class="efx-product-grid"></div>
          <div class="efx-search-all-products"></div>
        </section>
      </div>`;
    $results.__shell = true;
  }
  return $results.querySelector('.efx-product-grid');
}

function efxCardHTML(p) {
  const title = p.title || "";
  const shortTitle = title.length > 50 ? title.substring(0, 50) + "…" : title;
  function formatShopifyPrice(val) {
    const num = efxPriceNum(val);
    if (!isFinite(num)) return "";
    return num.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " TL";
  }
  // NOT: fiyatlar API'den metin gelebiliyor ("1.299,00"). Metin olarak
  // karşılaştırınca "999" > "1299" çıkıyor ve indirim rozeti yanlış ürüne
  // basılıyordu; ikisini de sayıya çeviriyoruz.
  const priceNum   = efxPriceNum(p.price);
  const compareNum = efxPriceNum(p.compareAtPrice);
  const price = formatShopifyPrice(p.price);
  const compareAtValid = isFinite(priceNum) && isFinite(compareNum) && compareNum > priceNum;
  const compareAt = compareAtValid ? formatShopifyPrice(p.compareAtPrice) : null;
  let discountBadge = "";
  if (compareAtValid) {
    const discount = Math.round(((compareNum - priceNum) / compareNum) * 100);
    discountBadge = `<div class="efx-discount-badge">-${discount}%</div>`;
  }
  // Growave wishlist — product-block.liquid ile birebir aynı placeholder markup'ı
  const pid = p.id || null;
  const vid = p.variantId || p.variant_id ||
    (Array.isArray(p.variants) && p.variants[0] && p.variants[0].id) || null;
  const wishlistHTML = pid
    ? `<div class="gw-add-to-wishlist-product-card-placeholder efx-wishlist"
           data-gw-product-id="${pid}"
           data-gw-variant-id="${vid || "null"}"
           data-gw-wishlist-counter-position="left-top"
           style="display: block; background:transparent !important"></div>`
    : "";
  return `
    <a class="efx-card" href="${efxEsc(p.url || "#")}" title="${efxEsc(title)}">
      <div class="efx-card-media">
        ${wishlistHTML}
        ${p.image ? `<img loading="lazy" src="${efxEsc(p.image)}" alt="${efxEsc(title)}">` : ""}
        ${discountBadge}
      </div>
      <div class="efx-card-details">
        <div class="efx-card-vendor">${efxEsc(p.vendor || "")}</div>
        <div class="efx-card-title">${efxEsc(shortTitle)}</div>
        ${price ? `<div class="efx-card-price">
            ${compareAt
              ? `<span class="efx-card-compare">${compareAt}</span> <span class="efx-card-final">${price}</span>`
              : `<span class="efx-card-final">${price}</span>`}
          </div>` : ""}
      </div>
    </a>
  `;
}

// NOT: Burada eskiden efxInitWishlist() vardı. "Growave geç yüklenmiş olabilir"
// diye window.gw.wishlist.init / window.Growave.wishlist.init aranıyordu.
// Canlıda ölçüldü: window.gw var ama wishlist.init YOK, yani fonksiyon hiçbir
// zaman bir şey yapmıyordu; kaldırıldı.

/* Kalpler yerleşene kadar kartları tut.
   ──────────────────────────────────────────────────────────────────
   Kalpleri Growave kendi gözlemcisiyle yerleştiriyor ve kartlar DOM'a
   yazıldıktan ~240 ms sonra ekliyor. Kartları hemen gösterirsek köşe önce boş
   kalıyor, sonra kalp beliriyor.

   Kalbe açılış animasyonu vermeyi denedik ve geri aldık: 0.18 sn'lik opaklık
   geçişinin kendisi kırpma gibi görünüyordu. Canlı ölçüm zaten yumuşatacak
   bir şey olmadığını gösterdi: buton TEK SEFERDE ekleniyor (yalnız "eklendi"
   olayları var, hiç kaldırma yok) ve arka plan rengi hiç değişmiyor.
   Sorun kalbin görünüşü değil, kartın bir süre kalpsiz görünmesi.

   Bu yüzden kalbi değil kartı bekletiyoruz: kalpler yerleşene kadar bekleyip
   hepsini tek seferde açıyoruz.

   Bekleme sırasında ekranda hiçbir şey DEĞİŞMEMELİ. İlk denemede kartlar
   gizlenip ortaya ayrı bir spinner çiziliyordu; o spinner arama akışının
   kendi spinner'ından farklı yerde durduğu için geçişte beyaz bir sıçrama
   oluyordu. Şimdi slider tamamen gizleniyor ve yerine aynı spinner'ın bir
   kopyası konuyor: kullanıcı açısından hiçbir şey değişmiyor, spinner
   yalnızca biraz daha dönüyor.

   Bekleme sınırlı: uygulama hiç yanıt vermezse kartlar kalpsiz de olsa
   açılır. Kalpsiz kart, boş ekrandan iyidir. */
const EFX_WISHLIST_WAIT = 700;

function efxHoldUntilWishlistReady(mountEl, devralinanSpinner) {
  // Önceki turdan kalan bekleyiciyi kapat. Kullanıcı yazarken kartlar arka
  // arkaya yeniden basılıyor; eski bekleyici, kendi (artık DOM'dan kopmuş)
  // placeholder'larını hazır sayıp yeni turu vaktinden önce açabilirdi.
  if (mountEl.__efxWishlistIptal) mountEl.__efxWishlistIptal();

  // Her tur temiz başlasın: aşağıdaki erken çıkışlardan birine düşersek
  // (kalp yok ya da hepsi zaten hazır) önceki turun gizleme sınıfı üzerinde
  // kalır ve kartlar bir daha hiç görünmezdi. Aynı iş bloğunda kaldırıp
  // gerekiyorsa geri koyduğumuz için arada boyama olmuyor.
  mountEl.classList.remove("efx-cards-pending");

  // Grid'in doğrudan altındaki her spinner (devralınan da dahil) buradan
  // kalkar; kartların açılması demek spinner'ın gitmesi demek.
  const spinneriKaldir = () => {
    mountEl.querySelectorAll(":scope > .efx-loading").forEach(el => el.remove());
  };

  const yerler = mountEl.querySelectorAll(".gw-add-to-wishlist-product-card-placeholder");
  if (!yerler.length) { spinneriKaldir(); return; }

  // "Buton var" yetmez, durumunu da bilmiş olmalı: data-in-wishlist yazıldığı
  // an bileşen favori listesini almış demektir. Sadece butonun varlığına
  // baksaydık, kalp önce çıkıp durumu gelince tazelenebilir ve yine göz
  // kırpardı.
  const hazir = (el) => !!el.querySelector(".gw-toggle-wishlist-product-card-button[data-in-wishlist]");
  const hepsiHazir = () => [...yerler].every(hazir);
  if (hepsiHazir()) { spinneriKaldir(); return; }

  mountEl.classList.add("efx-cards-pending");

  /* Bekleme göstergesi: aramadan devralınan spinner'ın TA KENDİSİ.
     Yerini ve görünümünü değiştirmiyoruz, sadece sınıf ekliyoruz — düğüm
     aynı kaldığı için animasyon kesintisiz sürüyor. Devralınacak bir şey
     yoksa (ör. kartlar spinner'sız yeniden basıldıysa) yenisini basıyoruz. */
  if (devralinanSpinner && devralinanSpinner.isConnected) {
    devralinanSpinner.classList.add("efx-cards-wait");
  } else {
    mountEl.insertAdjacentHTML("beforeend", efxSpinnerHTML("efx-cards-wait"));
  }

  let bitti = false;
  const kapat = () => {
    bitti = true;
    clearTimeout(sure);
    gozlemci.disconnect();
    if (mountEl.__efxWishlistIptal === kapat) mountEl.__efxWishlistIptal = null;
  };
  const ac = () => {
    if (bitti) return;
    kapat();
    spinneriKaldir();
    mountEl.classList.remove("efx-cards-pending");
  };

  // data-in-wishlist buton kurulduktan SONRA yazılıyor olabilir; yalnız
  // childList izlenseydi o durumda hiç haber alınmaz, her aramada zaman
  // aşımı beklenir ve arama boşuna 700 ms yavaşlardı.
  const gozlemci = new MutationObserver(() => { if (hepsiHazir()) ac(); });
  gozlemci.observe(mountEl, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["data-in-wishlist"],
  });
  const sure = setTimeout(ac, EFX_WISHLIST_WAIT);

  // İptal edilirse sınıf kaldırılmaz; yeni tur zaten kendi sınıfını koyuyor.
  mountEl.__efxWishlistIptal = kapat;
}

// Kalbe tıklayınca kartın linkine gidilmesin (Growave'in toggle'ı çalışmaya devam eder)
document.addEventListener("click", (e) => {
  // NOT: stopPropagation YOK — Growave'in kendi click handler'ına ulaşması gerekiyor.
  if (e.target.closest && e.target.closest(".efx-card .efx-wishlist")) e.preventDefault();
}, true);

// mountEl: içine slider yerleşecek container
// opts.emptyTitle / opts.emptySub: sonuç yokken basılacak metin
function efxInitSlider(mountEl, items, opts = {}) {
  if (!mountEl) return;
  const data = (items || []).slice(0, EFX_LIMIT);

  // Hiç ürün yoksa slider kurma. Eskiden boş bir slider basılıyordu:
  // ekranda hiçbir kart yokken oklar duruyor ve kullanıcı bomboş bir
  // alana bakıyordu.
  if (!data.length) {
    efxShowEmpty(mountEl, opts.emptyTitle, opts.emptySub);
    return;
  }

  const pages = efxChunk(data, EFX_SLIDE_SIZE);
  // Tek sayfa = kaydırılacak bir şey yok. Devre dışı ok da bir ok; hiç basmıyoruz.
  const multi = pages.length > 1;

  const sliderHTML = `
    <div class="efx-slider${multi ? "" : " efx-slider--single"}" data-page="0" aria-roledescription="carousel">
      ${multi ? `<button type="button" class="efx-slide-btn efx-prev" aria-label="Önceki" disabled><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="display:block;margin:auto"><polyline points="15 18 9 12 15 6"/></svg></button>` : ""}
      <div class="efx-track-wrap">
        <div class="efx-track" style="transform:translateX(0%)">
          ${pages.map(pg => `
            <div class="efx-page">
              ${pg.map(efxCardHTML).join("")}
            </div>
          `).join("")}
        </div>
      </div>
      ${multi ? `<button type="button" class="efx-slide-btn efx-next" aria-label="Sonraki"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="display:block;margin:auto"><polyline points="9 18 15 12 9 6"/></svg></button>` : ""}
    </div>
  `;

  /* innerHTML yerine "spinner'ı yerinde bırak, slider'ı önüne ekle".
     ────────────────────────────────────────────────────────────────
     Kalpler beklenecekse (aşağıda) spinner dönmeye devam edecek. innerHTML
     ile silip yenisini bassaydık — eskiden öyleydi — animasyon üçüncü kez
     sıfırlanır ve kullanıcı bir dönüş daha görürdü. */
  const mevcutSpinner = mountEl.querySelector(":scope > .efx-loading");
  Array.from(mountEl.children).forEach(ch => { if (ch !== mevcutSpinner) ch.remove(); });
  mountEl.insertAdjacentHTML("afterbegin", sliderHTML);

  // Kalpler Growave tarafından yerleştirilene kadar kartları göstermeyelim
  efxHoldUntilWishlistReady(mountEl, mevcutSpinner);

  if (!multi || window.innerWidth < 1200) return;

  const $slider = mountEl.querySelector(".efx-slider");
  const $track  = mountEl.querySelector(".efx-track");
  const $prev   = mountEl.querySelector(".efx-prev");
  const $next   = mountEl.querySelector(".efx-next");
  const pageCount = pages.length;

  function update(dir) {
    if (pageCount <= 1) return;
    let page = +$slider.dataset.page;
    if (dir === "next") page = Math.min(page + 1, pageCount - 1);
    if (dir === "prev") page = Math.max(page - 1, 0);
    $slider.dataset.page = page;
    $track.style.transform = `translateX(-${page * 100}%)`;
    if ($prev) $prev.disabled = page === 0;
    if ($next) $next.disabled = page === pageCount - 1;
  }

  $prev?.addEventListener("click", () => update("prev"));
  $next?.addEventListener("click", () => update("next"));

  let sx = 0, dx = 0;
  $track.addEventListener("touchstart", (e) => { sx = e.touches[0].clientX; }, {passive:true});
  $track.addEventListener("touchmove", (e) => { dx = e.touches[0].clientX - sx; }, {passive:true});
  $track.addEventListener("touchend", () => {
    if (Math.abs(dx) > 50) update(dx < 0 ? "next" : "prev");
    dx = 0;
  });
}

// === Fetchers ===
async function efxFetchPredictive(q) {
  const ck = `pred:${q}`;
  const c = efxGetCache(ck);
  if (c) return c;

  efxCtrl.pred = new AbortController();
  const p = new URLSearchParams({
    q,
    "resources[type]": EFX_TYPES,
    "resources[limit]": EFX_LIMIT_SEARCH
  });
  const res = await efxFetchWithTimeout(`/search/suggest.json?${p}`, {
    headers: { Accept: "application/json" },
    signal: efxCtrl.pred.signal
  }, 2200);
  if (!res.ok) throw new Error("HTTP " + res.status);
  const json = await res.json();
  efxSetCache(ck, json);
  return json;
}

// /search?view=efx-json şablonundan ürünler
async function efxFetchSearch(q) {
  const ck = `search:${q}`;
  const c = efxGetCache(ck);
  if (c) return c;

  efxCtrl.search = new AbortController();
  const url = `/search?view=efx-json&q=${encodeURIComponent(q)}`;
  const res = await efxFetchWithTimeout(url, {
    headers: { 'Accept': 'application/json' },
    signal: efxCtrl.search.signal
  }, 3500);
  if (!res.ok) throw new Error("Search fetch HTTP " + res.status);
  const json = await res.json();
  efxSetCache(ck, json);
  return json;
}

async function efxFetchPopularProducts(handle, limit = 20) {
  const ck = `pop:${handle}:${limit}`;
  const c = efxGetCache(ck);
  if (c) return c;
  const res = await efxFetchWithTimeout(`/collections/${handle}?view=efx-popular-json&limit=${limit}`, {}, 3500);
  if (!res.ok) throw new Error("Popular fetch HTTP " + res.status);
  const json = await res.json();
  efxSetCache(ck, json);
  return json;
}

// NOT: efxFetchVendorPopularProducts kaldirildi. Marka yuklemesi de
// efxFetchPopularProducts uzerinden koleksiyon handle'i ile yapiliyor
// (bkz. efxLoadPopularVendor); bu fonksiyon hicbir yerden cagrilmiyordu.

// === DOM ===
let $overlay = document.querySelector(".efx-search-overlay");
let $panel, $wrap, $results, $default;

if (!$overlay) {
  $overlay = document.createElement("div");
  $overlay.className = "efx-search-overlay";
  $panel = document.createElement("div");
  $panel.className = "custom-search-results";

  $wrap = document.createElement("div");
  $wrap.className = "custom-search-results__wrapper";

  $default = document.createElement("div");
  $default.className = "efx-search-default";
  $default.innerHTML = `
    <div class="efx-upper-bar">
      <div class="efx-vendors-bar">
        <h4 style="margin-bottom:0;">Popüler Markalar</h4>
        <ul class="efx-pop-vendors"></ul>
      </div>
      <div style="display:flex;">
        <button type="button" class="efx-popUp-close" aria-label="Kapat">✖</button>
      </div>
    </div>
    <div class="efx-cols">
      <aside class="efx-sidebar">
        <h4>Popüler Kategoriler</h4>
        <ul class="efx-pop-cats"></ul>
        <h4>Popüler Aramalar</h4>
        <ul class="efx-pop-queries"></ul>
      </aside>
      <section class="efx-main">
        <div class="efx-section-head">
          <div class="efx-section-title">Popüler Ürünler</div>
          <a class="efx-see-all-top" href="#" hidden>Tümünü Gör <span aria-hidden="true">→</span></a>
        </div>
        <div class="efx-product-grid"></div>
        <div class="efx-search-all-products"></div>
      </section>
    </div>
    <div class="efx-bottom">
      <h4 style="margin-bottom:0;">Geçmiş Aramalar</h4>
      <ul class="efx-pop-recent-search"></ul>
    </div>
  `;

  $results = document.createElement("div");
  $results.className = "efx-search-results";
  $results.hidden = true;

  // Mobil drawer header (CSS ile sadece <=767px gorunur)
  const drawerHdr = document.createElement("div");
  drawerHdr.className = "efx-drawer-header";
  drawerHdr.innerHTML = `
    <button type="button" class="efx-drawer-back" aria-label="Geri">
      <svg viewBox="0 0 10 16" width="11" height="18" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8.2 1.2 1.6 8l6.6 6.8"/></svg>
    </button>
    <div class="efx-drawer-input-wrap">
      <svg class="efx-drawer-search-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
      <input type="search" class="efx-drawer-input" autocomplete="off" placeholder="Marka veya Ürün Arayın" enterkeyhint="search" />
      <button type="button" class="efx-drawer-clear" aria-label="Temizle" hidden>
        <svg viewBox="0 0 14 14" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12"/></svg>
      </button>
    </div>
  `;

  $wrap.appendChild(drawerHdr);
  $wrap.appendChild($default);
  $wrap.appendChild($results);
  $panel.appendChild($wrap);
  $overlay.appendChild($panel);
  document.body.appendChild($overlay);
} else {
  // Overlay başka bir şablon tarafından basılmışsa referansları oradan al;
  // aksi halde $results/$default undefined kalıp panel hiç çalışmıyordu.
  $panel   = $overlay.querySelector(".custom-search-results");
  $wrap    = $overlay.querySelector(".custom-search-results__wrapper");
  $default = $overlay.querySelector(".efx-search-default");
  $results = $overlay.querySelector(".efx-search-results");
}

// Panel arkasındaki sayfayı tamamen kapatıyor (position:fixed; inset:0), yani
// davranışı bir modal. Ekran okuyucuya da böyle tanıtıyoruz; Tab tuzağı
// aşağıda (efxTrapTab) kuruluyor — biri diğeri olmadan yanlış olurdu.
// (Overlay tema tarafından basılmış olsa da uygulanmalı, o yüzden blok dışında.)
$overlay.setAttribute("role", "dialog");
$overlay.setAttribute("aria-modal", "true");
$overlay.setAttribute("aria-label", "Arama");

// === Render ===
// NOT: Burası yalnızca çiziyor. Eskiden activeHandle boşken içeriden
// efxLoadPopular çağırıyordu; efxOpen zaten aynı çağrıyı yaptığı için her
// açılışta aynı koleksiyon iki kez çekiliyor ve ikinci yanıt birincinin
// üstüne biniyordu.
function efxRenderPopularCats(cats, activeHandle) {
  if (!cats || !cats.length) return;
  const visibleCats = cats.slice(1);
  const catsEl = $default.querySelector(".efx-pop-cats");
  if (!catsEl) return;
  catsEl.innerHTML = visibleCats.map(c => `
    <li data-handle="${efxEsc(c.handle)}" class="${c.handle === activeHandle ? "is-active" : ""}">
      <a href="/collections/${encodeURIComponent(c.handle)}">
        <div class="cat-container">
          <span class="cat-title">${efxEsc(c.title)}</span>
          <span class="cat-arrow">→</span>
        </div>
      </a>
    </li>
  `).join("");

  const hoverLoad = efxBounce((handle, li) => {
    if (handle && handle !== activeCatHandle) {
      activeCatHandle = handle;
      catsEl.querySelectorAll("li[data-handle]").forEach(el => {
        el.classList.toggle("is-active", el === li);
      });
      inSearchMode = false;
      lastSearchResults = null;
      efxLoadPopular(handle);
    }
  }, 120);

  if (!efxIsCoarse()) {
    catsEl.querySelectorAll("li[data-handle]").forEach(li => {
      efxHoverIntent(li, () => { hoverLoad(li.dataset.handle, li); });
    });
  }
}

function efxRenderPopularVendors(vendors) {
  const vendorsEl = $default.querySelector(".efx-pop-vendors");
  vendorsEl.innerHTML = (vendors || []).map(v => `
    <li data-vendor-handle="${efxEsc(v.handle)}">
      <a href="/collections/${encodeURIComponent(v.handle)}">${efxEsc(v.title)}</a>
    </li>
  `).join("");

  if (efxIsCoarse()) return;

  const hoverLoadVendor = efxBounce((vendorHandle, li) => {
    if (!vendorHandle) return;
    activeVendorName = vendorHandle;
    vendorsEl.querySelectorAll("li[data-vendor-handle]").forEach(el => {
      el.classList.toggle("is-active", el === li);
    });
    inSearchMode = false;
    lastSearchResults = null;
    efxLoadPopularVendor(vendorHandle);
  }, 120);

  vendorsEl.querySelectorAll("li[data-vendor-handle]").forEach(li => {
    efxHoverIntent(li, () => { hoverLoadVendor(li.dataset.vendorHandle, li); });
  });
}

async function efxPreviewQuery(query) {
  const grid = $default.querySelector(".efx-product-grid");
  const myReq = ++efxPopularReqId;
  efxShowSpinner(grid);
  try {
    const data  = await efxFetchPredictive(query);
    if (myReq !== efxPopularReqId) return;
    const items = (data?.resources?.results?.products || []).slice(0, EFX_LIMIT);
    const normalized = items.map(it => ({
      id: it.id,
      variantId: it.variantId || (Array.isArray(it.variants) && it.variants[0] && it.variants[0].id) || "",
      url: it.url,
      image: it.image,
      title: it.title,
      price: it.price,
      compareAtPrice: it.compareAtPrice,
      handle: it.handle || efxExtractHandleFromUrl(it.url),
      vendor: it.vendor
    }));
    efxInitSlider(grid, normalized, {
      emptyTitle: EFX_TXT_EMPTY_TITLE,
      emptySub: EFX_TXT_EMPTY_SUB
    });
    // Popüler arama önizlemesinde aktif kategori/marka yok; renderSeeAllDefault
    // burada "/" üretiyordu. Bağlantı o sorgunun arama sayfasına gitmeli.
    const cont = $default.querySelector(".efx-search-all-products");
    if (cont) {
      cont.hidden = !normalized.length;
      cont.innerHTML = normalized.length
        ? `<a class="efx-see-all" href="/search?q=${encodeURIComponent(query)}&filter.v.availability=1&sort_by=relevance">Tüm Ürünleri Görüntüle</a>`
        : "";
    }
  } catch (err) {
    if (myReq !== efxPopularReqId) return;
    if (err?.name === "AbortError") return;
    efxShowError(grid);
    console.error(`Query preview (${query}) yüklenemedi:`, err);
  }
}

function efxRenderQueries(queries) {
  const qEl = $default.querySelector(".efx-pop-queries");
  qEl.innerHTML = (queries || []).map(q => `
    <li data-query="${efxEsc(q)}">
      <a href="/search?q=${encodeURIComponent(q)}" class="query-container">
        <span class="query-title">${efxEsc(q)}</span>
        <span class="cat-arrow">→</span>
      </a>
    </li>
  `).join("");

  const hoverLoadQuery = efxBounce((query, li) => {
    if (!query) return;
    qEl.querySelectorAll("li[data-query]").forEach(el => {
      el.classList.toggle("is-active", el === li);
    });
    const catsEl = $default.querySelector(".efx-pop-cats");
    if (catsEl) catsEl.querySelectorAll("li.is-active").forEach(el => el.classList.remove("is-active"));
    const vendorsEl = $default.querySelector(".efx-pop-vendors");
    if (vendorsEl) vendorsEl.querySelectorAll("li.is-active").forEach(el => el.classList.remove("is-active"));
    activeCatHandle  = null;
    activeVendorName = null;
    efxPreviewQuery(query);
  }, 120);

  if (!efxIsCoarse()) {
    qEl.querySelectorAll("li[data-query]").forEach(li => {
      efxHoverIntent(li, () => { hoverLoadQuery(li.dataset.query, li); });
    });
  }
}

// === Dedup helpers ===
function efxExtractHandleFromUrl(url) {
  if (!url) return "";
  try {
    const u = new URL(url, location.origin);
    const parts = u.pathname.split("/").filter(Boolean);
    const i = parts.indexOf("products");
    return (i !== -1 && parts[i + 1]) ? parts[i + 1].toLowerCase() : "";
  } catch { return ""; }
}
/* Fiyatı sayıya çevir.
   ──────────────────────────────────────────────────────────────────
   İki ayrı kaynaktan besleniyoruz ve biçimleri farklı:
   - search.efx-json / collection.efx-popular-json şablonları sayı veriyor (199.9)
   - /search/suggest.json ise mağaza para biçiminde METİN veriyor ("1.299,00 TL")

   Eski hâli metni yalnız ilk virgülü noktaya çevirerek okuyordu:
   "1.299,00" → parseFloat("1.299.00") = 1.299. Yani predictive'den gelen
   1.299 TL'lik bir ürün kartta "1,30 TL" yazıyor, indirim rozeti de bu yanlış
   sayıyla hesaplanıyordu.

   Kural: ikisi de varsa SONDAKİ ayraç ondalıktır, diğeri binliktir. Tek ayraç
   varsa ardından tam 3 hane geliyorsa (veya ayraç birden fazlaysa) binliktir. */
function efxPriceNum(val) {
  if (val == null) return NaN;
  if (typeof val === "number") return isFinite(val) ? val : NaN;
  let s = String(val).replace(/[^\d.,-]/g, "").trim();
  if (!s) return NaN;

  const lastComma = s.lastIndexOf(",");
  const lastDot   = s.lastIndexOf(".");

  if (lastComma > -1 && lastDot > -1) {
    const dec = Math.max(lastComma, lastDot);
    s = s.slice(0, dec).replace(/[.,]/g, "") + "." + s.slice(dec + 1);
  } else if (lastComma > -1) {
    const frac = s.length - lastComma - 1;
    s = (frac === 3 || s.indexOf(",") !== lastComma)
      ? s.replace(/,/g, "")
      : s.replace(",", ".");
  } else if (lastDot > -1) {
    const frac = s.length - lastDot - 1;
    if (frac === 3 || s.indexOf(".") !== lastDot) s = s.replace(/\./g, "");
  }

  const n = parseFloat(s);
  return isFinite(n) ? n : NaN;
}
function efxDedupKey(it) {
  if (it.id) return `id:${it.id}`;
  const handle = (it.handle || efxExtractHandleFromUrl(it.url) || "").trim().toLowerCase();
  if (handle) return `h:${handle}`;
  const t = (it.title || "").toLowerCase().trim();
  const p = efxPriceNum(it.price);
  return `tp:${t}:${isNaN(p) ? "nan" : p.toFixed(2)}`;
}

// === Vendor list & products render ===
let activeCatHandle   = (window.EFX_SETTINGS?.popularCats || [])[0]?.handle || null;
let activeVendorName  = null;

function showProducts(items) {
  const mount = $results.querySelector(".efx-product-grid") || $default.querySelector(".efx-product-grid");
  if (!mount) return;
  const normalized = (items || []).slice(0, EFX_LIMIT).map(it => ({
    id: it.id,
    variantId: it.variantId || it.variant_id ||
      (Array.isArray(it.variants) && it.variants[0] && it.variants[0].id) || "",
    url: it.url,
    image: it.image,
    title: it.title,
    price: it.price,
    compareAtPrice: it.compareAtPrice,
    handle: it.handle || efxExtractHandleFromUrl(it.url),
    vendor: it.vendor
  }));
  efxInitSlider(mount, normalized, {
    emptyTitle: EFX_TXT_EMPTY_TITLE,
    emptySub: EFX_TXT_EMPTY_SUB
  });
}

function renderVendorList(vendors, query) {
  const vendorsEl = $results.querySelector(".efx-pop-vendors");
  if (!vendorsEl) return;

  const base = Array.isArray(vendors) ? vendors : [];
  let filtered = base;

  if (Array.isArray(dbVendors) && dbVendors.length > 0) {
    filtered = base.filter(vn => {
      const row = efxFindDbVendor(vn);
      return row && efxIsVendorActive(row);
    });
  }
  const limited = filtered.slice(0, 8);

  vendorsEl.innerHTML = limited.map(vn => {
    const collUrl = efxGetVendorCollectionUrl(vn);
    const href = collUrl ? collUrl : efxVendorSearchHref(query, vn);
    return `<li data-vendor-name="${efxEsc(vn)}"><a href="${efxEsc(href)}">${efxEsc(vn)}</a></li>`;
  }).join("");

  // Marka yoksa "Markalar" başlığı boş bir şeridin üstünde asılı kalmasın.
  const bar = vendorsEl.closest(".efx-vendors-bar");
  if (bar) bar.hidden = !limited.length;

  if (efxIsCoarse()) return;

  vendorsEl.querySelectorAll('li[data-vendor-name]').forEach(li => {
    efxHoverIntent(li, () => {
      if (!inSearchMode || !lastSearchResults) return;
      activeVendorName = li.dataset.vendorName;
      vendorsEl.querySelectorAll("li").forEach(el =>
        el.classList.toggle("is-active", el === li)
      );
      const filteredProducts = lastSearchResults.filter(it => it.vendor === activeVendorName);
      showProducts(filteredProducts);
      renderSeeAllResults(query, filteredProducts.length > 0);
    });
  });
}

// === See All button helpers ===
function renderSeeAllDefault() {
  const cont = $default.querySelector(".efx-search-all-products");
  let href = "/";
  if (activeCatHandle) {
    href = `/collections/${activeCatHandle}`;
  } else if (activeVendorName) {
    href = `/collections/${activeVendorName}`;
  }
  if (cont) {
    cont.hidden = false;
    cont.innerHTML = `<a class="efx-see-all" href="${href}">Tüm Ürünleri Görüntüle</a>`;
  }
  // Arama yokken (varsayılan görünüm) üstteki "Tümünü Gör" gizli (kullanıcı kararı)
  const top = $default.querySelector(".efx-see-all-top");
  if (top) top.hidden = true;
}
// hasResults=false iken "Tümünü Gör" basılmaz: aynı sorgunun sonuç sayfası da
// boş olacağı için kullanıcıyı ikinci bir boş ekrana göndermenin anlamı yok.
function renderSeeAllResults(query, hasResults = true) {
  const q = (query || "").trim();
  let href = `/search?q=${encodeURIComponent(q)}&filter.v.availability=1&sort_by=relevance`;
  if (activeVendorName) href += `&filter.p.vendor=${encodeURIComponent(activeVendorName)}`;
  const show = !!q && !!hasResults;
  const cont = $results.querySelector(".efx-search-all-products");
  if (cont) {
    // İçini boşaltmak yetmiyor: kabın kendi border-top'u sonuç yokken ekranda
    // yalnız bir çizgi olarak kalıyordu.
    cont.hidden = !show;
    cont.innerHTML = show ? `<a class="efx-see-all" href="${href}">Tüm Ürünleri Görüntüle</a>` : "";
  }
  // Arama varken üstteki "Tümünü Gör →" arama sayfasına gider; boşken gizli
  const top = $results.querySelector(".efx-see-all-top");
  if (top) { top.setAttribute("href", href); top.hidden = !show; }
}

// onPick verilirse geçmiş arama tıklaması sayfayı değiştirmez, aramayı panelde
// çalıştırır. (Eskiden efxOpen bir onPick gönderiyordu ama bu fonksiyon onu hiç
// almıyordu; tıklayınca panel kapanıp /search'e gidiliyordu.)
function renderRecentSearches(mountEl, onPick) {
  if (!mountEl) return;
  const items = getRecentSearches();
  const wrap = mountEl.closest(".efx-bottom");
  if (wrap) wrap.hidden = !items.length;
  if (!items.length) { mountEl.innerHTML = ""; return; }

  mountEl.innerHTML = items.map(q => `
    <li class="efx-recent-li">
      <button class="efx-recent-item" type="button" data-q="${efxEsc(q)}">${efxEsc(q)}</button>
      <button class="efx-recent-remove" type="button" data-q="${efxEsc(q)}" title="Kaldır" aria-label="Kaldır">×</button>
    </li>
  `).join("");

  if (mountEl.__recentHandler) {
    mountEl.removeEventListener("click", mountEl.__recentHandler);
  }
  mountEl.__recentHandler = (e) => {
    const removeBtn = e.target.closest(".efx-recent-remove");
    if (removeBtn) {
      e.preventDefault(); e.stopPropagation();
      const q = removeBtn.dataset.q || "";
      if (!q) return;
      const arr = getRecentSearches().filter(item => item.trim() !== q.trim());
      setRecentSearches(arr);
      const li = removeBtn.closest(".efx-recent-li");
      if (li) li.remove();
      if (!arr.length) {
        mountEl.innerHTML = "";
        if (wrap) wrap.hidden = true;
      }
      return;
    }
    const pickBtn = e.target.closest(".efx-recent-item");
    if (!pickBtn) return;
    const q = pickBtn.dataset.q || "";
    if (!q) return;
    if (typeof onPick === "function") { onPick(q); return; }
    window.location.href = `/search?q=${encodeURIComponent(q)}&filter.v.availability=1&sort_by=relevance`;
  };
  mountEl.addEventListener("click", mountEl.__recentHandler);
}

// ——— Predictive + Search birleştir, SPINNER ile render et ———
async function efxLoadPopularSearch(query) {
  efxCancelInFlight();
  const myReq = ++efxSearchReqId;
  efxCurrentQuery = query;

  try {
    // sonuç kabuğu + spinner (hemen boyansın)
    const grid = efxEnsureResultsShell();
    const qEl = $results.querySelector('.efx-query'); if(qEl) qEl.textContent = `“${query}”`;
    if (efxShowSpinner(grid)) await efxNextPaint();

    // aktif durumları paint'ten sonra sıfırla
    $default.querySelector(".efx-pop-cats")?.querySelectorAll("li.is-active").forEach(li => li.classList.remove("is-active"));
    $default.querySelector(".efx-pop-vendors")?.querySelectorAll("li.is-active").forEach(li => li.classList.remove("is-active"));
    activeCatHandle = null; activeVendorName = null;

    // predictive + search paralel (biri çökerse diğeri devam)
    const [predSet, searchSet] = await Promise.allSettled([
      efxFetchPredictive(query),
      efxFetchSearch(query)
    ]);
    if (myReq !== efxSearchReqId) return;

    const predItems = (predSet.status==='fulfilled'
      ? (predSet.value?.resources?.results?.products||[]) : []);
    const searchArray = (searchSet.status==='fulfilled' && Array.isArray(searchSet.value))
      ? searchSet.value : [];

    // merge + dedup
    const seen = new Set();
    const merged = [...predItems, ...searchArray].filter(it => {
      const key = efxDedupKey(it);
      if (!key || seen.has(key)) return false;
      seen.add(key); return true;
    });

    inSearchMode = true;
    lastSearchResults = merged;

    // Sonuç yok. İki isteğin de düşmesiyle "gerçekten sonuç yok"u ayırıyoruz:
    // ağ çöktüğünde kullanıcıya "ürün bulunamadı" demek yanlış bilgi olur.
    if (!merged.length) {
      const bothFailed = predSet.status === 'rejected' && searchSet.status === 'rejected';
      if (bothFailed) {
        efxShowError(grid);
      } else {
        efxShowEmpty(grid, EFX_TXT_EMPTY_TITLE, EFX_TXT_EMPTY_SUB);
      }
      renderVendorList([], query);
      renderSeeAllResults(query, false);
      efxUpdateSidebarVisibility();
      return;
    }

    // spinner yerine ürünleri bas
    efxInitSlider(grid, merged);

    // vendor listesi + "Tümünü Gör"
    const uniqVendors = Array.from(new Set(merged.map(it=>it.vendor).filter(Boolean)));
    renderVendorList(uniqVendors, query);
    renderSeeAllResults(query, true);
    efxUpdateSidebarVisibility();

  } catch (err) {
    if (myReq !== efxSearchReqId) return;
    if (err?.name === "AbortError") return;
    inSearchMode = false;
    lastSearchResults = null;
    // Hatayı grid'in içine basıyoruz. Eskiden $results.innerHTML eziliyordu ama
    // __shell işareti duruyordu: sonraki aramada kabuk yeniden kurulmadığı için
    // grid bulunamıyor ve panel bir daha hiç sonuç göstermiyordu.
    const grid = $results.querySelector(".efx-product-grid");
    if (grid) {
      efxShowError(grid);
      renderVendorList([], query);
      renderSeeAllResults(query, false);
    } else {
      $results.innerHTML = `<div class="efx-error">${efxEsc(EFX_TXT_ERROR)}</div>`;
      delete $results.__shell;
    }
    console.error(err);
  }
}

function efxRenderProducts(products) {
  const grid = $default.querySelector(".efx-product-grid");
  efxInitSlider(grid, products, {
    emptyTitle: "Bu listede gösterilecek ürün yok",
    emptySub: "Başka bir kategori veya marka seçebilirsiniz."
  });
  renderSeeAllDefault();
}

// === Data ===
const popularCats    = window.EFX_SETTINGS?.popularCats || [];
const popularQueries = window.EFX_SETTINGS?.popularQueries || [];
const popularVendors = window.EFX_SETTINGS?.popularVendors || [];

// === Load ===
async function efxLoadPopular(handle) {
  if (!handle) return;
  // Kategoriler arasında hızlı gezinirken yavaş kalan eski yanıt, yenisinin
  // üstüne biniyordu; her yüklemeye sıra numarası veriyoruz.
  const myReq = ++efxPopularReqId;
  const grid = $default.querySelector(".efx-product-grid");
  try {
    inSearchMode = false;
    lastSearchResults = null;

    if (efxShowSpinner(grid)) await efxNextPaint();

    const products = await efxFetchPopularProducts(handle, 20);
    if (myReq !== efxPopularReqId) return;
    activeCatHandle = handle;

    const catsEl = $default.querySelector(".efx-pop-cats");
    if (catsEl) {
      catsEl.querySelectorAll("li[data-handle]").forEach(li => {
        li.classList.toggle("is-active", li.dataset.handle === activeCatHandle);
      });
    }
    const vendorsEl = $default.querySelector(".efx-pop-vendors");
    if (vendorsEl) vendorsEl.querySelectorAll("li.is-active").forEach(li => li.classList.remove("is-active"));
    const queriesEl = $default.querySelector(".efx-pop-queries");
    if (queriesEl) queriesEl.querySelectorAll("li.is-active").forEach(li => li.classList.remove("is-active"));

    activeVendorName = null;
    efxRenderProducts(products);
  } catch (err) {
    if (myReq !== efxPopularReqId) return;
    if (err?.name !== "AbortError") efxShowError(grid);
    console.error(`Popüler ürünler (${handle}) yüklenemedi:`, err);
  }
}

async function efxLoadPopularVendor(vendorHandle) {
  if (!vendorHandle) return;
  const myReq = ++efxPopularReqId;
  const grid = $default.querySelector(".efx-product-grid");
  try {
    inSearchMode = false;
    lastSearchResults = null;

    if (efxShowSpinner(grid)) await efxNextPaint();

    const products = await efxFetchPopularProducts(vendorHandle, 20); // vendor değil, koleksiyon handle
    if (myReq !== efxPopularReqId) return;
    activeVendorName = vendorHandle;

    const vendorsEl = $default.querySelector(".efx-pop-vendors");
    if (vendorsEl) {
      vendorsEl.querySelectorAll("li[data-vendor-handle]").forEach(li => {
        li.classList.toggle("is-active", li.dataset.vendorHandle === activeVendorName);
      });
    }
    const catsEl = $default.querySelector(".efx-pop-cats");
    if (catsEl) catsEl.querySelectorAll("li.is-active").forEach(li => li.classList.remove("is-active"));
    const queriesEl = $default.querySelector(".efx-pop-queries");
    if (queriesEl) queriesEl.querySelectorAll("li.is-active").forEach(li => li.classList.remove("is-active"));

    activeCatHandle = null;
    efxRenderProducts(products);
  } catch (err) {
    if (myReq !== efxPopularReqId) return;
    if (err?.name !== "AbortError") efxShowError(grid);
    console.error(`Popüler vendor (${vendorHandle}) yüklenemedi:`, err);
  }
}

// === Mobil body scroll lock ===
// iOS Safari preventScroll'u guvenilir desteklemiyor: drawer input'a focus
// verince sayfa yukari kayar. Bunu engellemek icin body'yi position:fixed yapip
// scroll Y'yi negative top olarak korur, drawer kapaninca geri yukleriz.
let efxScrollY = 0;
function efxLockScroll() {
  if (!efxIsMobile()) return;
  // Cat drawer zaten kilitlemis olabilir (m-cat-lock). Yeniden kilitleme.
  if (document.body.classList.contains('m-cat-lock')) return;
  if (document.body.style.position === 'fixed') return;
  efxScrollY = window.scrollY || window.pageYOffset || 0;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${efxScrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
}
function efxUnlockScroll() {
  if (!efxIsMobile()) return;
  // Mevcut top'u oku (bizim veya cat drawer'in koymus olabilir).
  const existingTop = document.body.style.top;
  const restoreY = existingTop ? Math.abs(parseInt(existingTop, 10)) : efxScrollY;
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  document.body.classList.remove('m-cat-lock'); // cat drawer arka planda acik kalmissa onu da temizle
  if (restoreY) window.scrollTo(0, restoreY);
}

// === Panel kontrol ===
function efxOpen() {
  // Panel açıkken tekrar çağrılmamalı. Kullanıcı sonuçlar dururken sorguyu
  // düzeltmek için inputa tıkladığında (input'un click/focus dinleyicileri
  // buraya bağlı) tüm durum sıfırlanıyor, ekran varsayılana dönüp aramayı
  // baştan yapıyordu. Odak tuzağı da inputa odak verdiği için bu koruma şart.
  if ($overlay.classList.contains("is-open")) return;

  // Panel kapanınca odağın döneceği yeri sakla.
  efxLastFocused = document.activeElement;

  inSearchMode = false;
  lastSearchResults = null;

  // Mobilde body'yi kilitle: focus drawer input'a sayfa kaymasin
  efxLockScroll();

  $overlay.classList.add("is-open");
  document.body.classList.add("efx-no-scroll");
  $default.hidden = false;
  $results.hidden = true;

  // Mobil: page input degerini drawer input'a kopyala
  if (efxIsMobile()) {
    const pageInp = document.querySelector('.efx-main-search__input');
    const drawerInp = document.querySelector('.efx-drawer-input');
    if (pageInp && drawerInp) {
      drawerInp.value = pageInp.value;
      const clearBtn = document.querySelector('.efx-drawer-clear');
      if (clearBtn) clearBtn.hidden = !drawerInp.value;
    }
  }

  // Önce aktif kategoriyi belirle, sonra çiz: liste doğru öğeyi işaretli açsın.
  if (!activeCatHandle && popularCats.length) {
    activeCatHandle = popularCats[0].handle;
  }

  if (popularVendors.length) {
    efxRenderPopularVendors(popularVendors);
  }
  efxRenderPopularCats(popularCats, activeCatHandle);
  efxRenderQueries(popularQueries);

  const recentMount = $default.querySelector(".efx-pop-recent-search");
  renderRecentSearches(recentMount, (pickedQ) => {
    // Mobilde drawer input aktif, desktop'ta page input
    const activeInput = efxIsMobile()
      ? document.querySelector(".efx-drawer-input")
      : document.querySelector(".efx-main-search__input");
    if (activeInput) {
      activeInput.value = pickedQ;
      const clearBtn = document.querySelector('.efx-drawer-clear');
      if (clearBtn && efxIsMobile()) clearBtn.hidden = !activeInput.value;
      onTypeImmediate({ target: activeInput });
      onType({ target: activeInput });
    }
  });

  const activeInput = efxIsMobile()
    ? document.querySelector(".efx-drawer-input")
    : document.querySelector(".efx-main-search__input");
  if (activeInput && activeInput.value.trim().length >= EFX_MIN_LEN) {
    onType({ target: activeInput });
    return;
  }

  if (activeCatHandle) efxLoadPopular(activeCatHandle);
  efxUpdateSidebarVisibility();
}

function efxClose() {
  // Mobil: drawer input degerini page input'a geri yaz (kullanici acipsa kapatirsa value korunur)
  if (efxIsMobile()) {
    const pageInp = document.querySelector('.efx-main-search__input');
    const drawerInp = document.querySelector('.efx-drawer-input');
    if (pageInp && drawerInp) pageInp.value = drawerInp.value;
    // Klavyeyi kapat
    if (drawerInp) try { drawerInp.blur(); } catch {}
  }

  $overlay.classList.remove("is-open");
  document.body.classList.remove("efx-no-scroll");
  efxUnlockScroll(); // mobil body lock'u kaldir
  efxResetAll();
  efxUpdateSidebarVisibility();
  efxRestoreFocus();
}

function efxResetAll() {
  inSearchMode = false;
  lastSearchResults = null;

  activeCatHandle = null;
  activeVendorName = null;

  document.querySelectorAll(".efx-search-overlay .is-active").forEach(el => el.classList.remove("is-active"));

  const gridDefault = $default?.querySelector(".efx-product-grid");
  if (gridDefault) gridDefault.innerHTML = "";

  if ($results) {
    $results.innerHTML = "";
    $results.hidden = true;
    delete $results.__shell;
  }

  if ($default) $default.hidden = false;
  renderSeeAllDefault();
  efxUpdateSidebarVisibility();
}

$overlay.addEventListener("click", (e) => {
  if (e.target === $overlay) efxClose();
});

// Kapatma butonu artık inline onclick değil (CSP dostu ve kabuk yeniden
// basıldığında da çalışıyor).
$overlay.addEventListener("click", (e) => {
  if (e.target.closest(".efx-popUp-close")) efxClose();
});

/* ——— Odak yönetimi ———
   Masaüstünde arama inputu overlay'in DIŞINDA (header'da) kalıyor ama panel
   açıkken kullanıcı orada yazıyor. Bu yüzden tuzağın kapsamı "overlay" değil,
   "input + overlay". Sadece overlay'i çevreleseydik Tab, kullanıcıyı yazdığı
   inputtan atardı. */
let efxLastFocused = null;

function efxVisible(el) {
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}
function efxFocusScope() {
  const sel = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  const list = Array.from($overlay.querySelectorAll(sel)).filter(efxVisible);
  // Mobilde drawer kendi inputunu taşıyor ve sayfa inputu drawer'ın ARKASINDA
  // kalıyor: görünür ölçülür ama kullanıcı onu göremez, kapsama alınmamalı.
  // Masaüstünde ise panel açıkken kullanıcı o inputta yazıyor, kapsamın başında.
  if (!efxIsMobile()) {
    const pageInput = document.querySelector(".efx-main-search__input");
    if (pageInput && !$overlay.contains(pageInput) && efxVisible(pageInput)) {
      list.unshift(pageInput);
    }
  }
  return list;
}
function efxTrapTab(e) {
  if (e.key !== "Tab") return;
  if (!$overlay.classList.contains("is-open")) return;
  const list = efxFocusScope();
  if (!list.length) return;
  const first = list[0];
  const last  = list[list.length - 1];
  const idx   = list.indexOf(document.activeElement);
  if (idx === -1) {
    e.preventDefault();
    (e.shiftKey ? last : first).focus({ preventScroll: true });
  } else if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault();
    first.focus({ preventScroll: true });
  } else if (e.shiftKey && document.activeElement === first) {
    e.preventDefault();
    last.focus({ preventScroll: true });
  }
}
document.addEventListener("keydown", efxTrapTab);

function efxRestoreFocus() {
  const el = efxLastFocused;
  efxLastFocused = null;
  if (!el || !document.contains(el)) return;
  if ($overlay.contains(el)) return;
  // Arama inputuna odak vermek paneli yeniden açardı (input'un focus
  // dinleyicisi efxOpen'a bağlı); o durumda odağı olduğu yerde bırakıyoruz.
  if (el.matches && el.matches(".efx-main-search__input, .efx-drawer-input")) return;
  try { el.focus({ preventScroll: true }); } catch {}
}
document.addEventListener("keydown", (e) => {
  // Panel kapalıyken de efxClose çalışıyordu: her Escape'te gereksiz yere
  // tüm durum sıfırlanıyor ve mobil scroll kilidi açılmaya çalışılıyordu.
  if (e.key === "Escape" && $overlay.classList.contains("is-open")) efxClose();
});

// Arama sonucundan çıkışlar (kart / "Tümünü Gör") geçmiş aramalara yazılsın.
$overlay.addEventListener("click", (e) => {
  if (!inSearchMode || !efxCurrentQuery) return;
  if (e.target.closest(".efx-card, .efx-see-all, .efx-see-all-top")) {
    saveRecentSearch(efxCurrentQuery);
  }
});

// === Input dinleme ===
const inputs = document.querySelectorAll(".efx-main-search__input");
inputs.forEach((inp) => {
  inp.addEventListener("focus", efxOpen);
  inp.addEventListener("click", efxOpen);

  // Mobil: page input focus'unu drawer input'a yonlendir.
  // pointerdown native focus'tan once tetiklenir; preventDefault ile page input
  // focus olmaz, drawer acilir ve drawer input ayni user-gesture icinde focus alir
  // (iOS klavye gostermek icin bu sart).
  inp.addEventListener("pointerdown", (e) => {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    e.preventDefault();
    const drawerInp = document.querySelector('.efx-drawer-input');
    if (!drawerInp) { efxOpen(); return; }
    drawerInp.value = inp.value;
    efxOpen();
    drawerInp.focus({ preventScroll: true });
    try {
      drawerInp.setSelectionRange(drawerInp.value.length, drawerInp.value.length);
    } catch {}
  });
});

// Paneli aç ve yazılacak yere odaklan (mobilde drawer inputu, masaüstünde
// header inputu). Kullanıcı hareketinin içinden çağrılmalı: iOS klavyeyi
// ancak öyle açıyor.
function efxOpenVeOdakla() {
  efxOpen();
  const hedef = efxIsMobile()
    ? document.querySelector('.efx-drawer-input')
    : document.querySelector('.efx-main-search__input');
  if (!hedef) return;
  try { hedef.focus({ preventScroll: true }); } catch {}
  try { hedef.setSelectionRange(hedef.value.length, hedef.value.length); } catch {}
}

/* Form submit.
   ──────────────────────────────────────────────────────────────────
   Dolu ise geçmişe yazıp normal submit (arama sayfasına gider).

   BOŞ ise hiçbir yere gitmiyoruz. Eskiden masaüstünde boş input ile Enter
   /search?q= adresine gidiyordu ve o sayfa bomboş açılıyor: main-search.liquid
   tüm içeriği {% if search.performed %} içinde, boş sorguda search.performed
   false olduğu için bölüm hiçbir şey basmıyor. Bunun yerine arama panelini
   açıp odağı inputa veriyoruz.

   (Geçmiş kaydı eskiden yalnız mobil drawer'daki Enter'da yapılıyordu, bu
    yüzden masaüstünde "Geçmiş Aramalar" hiçbir zaman dolmuyordu.) */
document.querySelectorAll('.main-search__form').forEach((form) => {
  form.addEventListener('submit', (e) => {
    const inp = form.querySelector('.efx-main-search__input');
    if (!inp) return;
    const q = inp.value.trim();
    if (q) { saveRecentSearch(q); return; } // normal submit (search sayfasina git)

    e.preventDefault();
    // Yalnız boşluk yazılmışsa temizle: aksi halde panel "arama var" sanıp
    // boşluk için sonuç aramaya kalkardı.
    if (inp.value) inp.value = "";
    efxOpenVeOdakla();
  });
});

// Boş sorgu sayfasındaki (/search?q=) "Aramayı Aç" düğmesi — bkz.
// sections/main-search.liquid. Delegasyon: düğme her şablonda olmayabilir.
document.addEventListener('click', (e) => {
  const btn = e.target.closest && e.target.closest('.js-efx-open-search');
  if (!btn) return;
  e.preventDefault();
  efxOpenVeOdakla();
});

// Mobil float arama butonu (.m-float-search): drawer'i ac.
// Delegasyon kullaniyoruz: tum sablonlarda (collection dahil) ve header yeniden
// render olsa bile calisir. pointerdown ile preventDefault + ayni gesture icinde
// drawer input'u focus ediyoruz (iOS klavyesi icin sart).
document.addEventListener("pointerdown", (e) => {
  const btn = e.target.closest && e.target.closest(".m-float-search");
  if (!btn) return;
  if (!window.matchMedia('(max-width: 767px)').matches) { efxOpen(); return; }
  e.preventDefault();
  efxOpen();
  const drawerInp = document.querySelector('.efx-drawer-input');
  if (drawerInp) {
    drawerInp.focus({ preventScroll: true });
    try { drawerInp.setSelectionRange(drawerInp.value.length, drawerInp.value.length); } catch {}
  }
});

// 1) ANINDA spinner (debounce YOK) — sadece UI
async function onTypeImmediate(ev){
  const q = ev.target.value.trim();

  if (q.length < EFX_MIN_LEN) {
    efxCancelInFlight(); // önceki aramayı iptal et
    // Arama görünümünden geri dönüyorsak ya da varsayılan grid boşsa yükle.
    // Eskiden her tuşa basışta yeniden çekiliyordu: iki harfi silerken üst üste
    // istek çıkıyor ve grid boş/dolu arasında titriyordu.
    const grid = $default.querySelector(".efx-product-grid");
    const needsLoad = inSearchMode || !$results.hidden || !grid || !grid.firstElementChild;
    inSearchMode = false;
    lastSearchResults = null;
    efxCurrentQuery = "";
    $default.hidden = false;
    $results.hidden = true;
    if (!activeCatHandle && popularCats.length) activeCatHandle = popularCats[0].handle;
    // Popülerler asenkron yüklenir (spinner içeride)
    if (activeCatHandle && needsLoad) efxLoadPopular(activeCatHandle);
    efxUpdateSidebarVisibility();
    return;
  }

  // Arama modu — sonuç kabuğunu hazırla ve spinner'ı ANINDA göster
  const gridEarly = efxEnsureResultsShell();
  const qElEarly = $results.querySelector('.efx-query'); if (qElEarly) qElEarly.textContent = `“${q}”`;
  // Spinner zaten dönüyorsa yeniden basmıyoruz; o durumda beklenecek bir
  // boyama da yok.
  if (efxShowSpinner(gridEarly)) await efxNextPaint();
}

// 2) AĞ çağrılarını yapan debounce'lu handler
const onType = efxBounce(async (ev) => {
  const q = ev.target.value.trim();

  if (q.length < EFX_MIN_LEN) {
    // (onTypeImmediate zaten UI'ı geri aldı)
    return;
  }

  // efxLoadPopularSearch kendi hatasını zaten grid içinde gösteriyor;
  // burada sadece beklenmedik bir şey kaçarsa loglayalım.
  try {
    await efxLoadPopularSearch(q);
  } catch (err) {
    if (err?.name !== "AbortError") console.error(err);
  }
}, 220);

// Mobil drawer mode helper
const efxIsMobile = () => window.matchMedia('(max-width: 767px)').matches;

// Overlay top offset (sticky header/announcement bar için)
function updateOverlayTop() {
  const overlay = document.querySelector('.efx-search-overlay');
  if (!overlay) return;

  // Mobilde drawer full-screen
  if (efxIsMobile()) {
    overlay.style.setProperty('--efx-overlay-top', '0px');
    return;
  }

  // 1) Tercihen arama inputunun altına hizala
  const input = document.querySelector('.efx-main-search__input');
  let topPx = 100; // desktop varsayılanı

  topPx = (window.innerWidth > 1200)
      ? (window.scrollY > 40 ? 65 : 100)
      : 100;

  overlay.style.setProperty('--efx-overlay-top', `${topPx}px`);
}

window.addEventListener('scroll', updateOverlayTop, { passive: true });
window.addEventListener('resize', updateOverlayTop);
// Genişlik 1200'ü geçince slider kurulmuyordu/kuruluyordu; yeniden çizmeden
// en azından kenar çubuğu görünürlüğü doğru kalsın.
window.addEventListener('resize', efxBounce(efxUpdateSidebarVisibility, 150));
document.addEventListener('DOMContentLoaded', () => {
  updateOverlayTop();
  renderSeeAllDefault();
  efxUpdateSidebarVisibility();
});

// input değişimini bağla
inputs.forEach((el) => {
  el.addEventListener("input", onTypeImmediate); // ← hemen spinner
  el.addEventListener("input", onType);          // ← debounce’lu fetch
});

// === Mobil drawer header wiring ===
(function wireDrawerHeader(){
  const drawerInp = document.querySelector('.efx-drawer-input');
  const backBtn   = document.querySelector('.efx-drawer-back');
  const clearBtn  = document.querySelector('.efx-drawer-clear');
  if (!drawerInp) return;

  // Yazma -> mevcut search handler'lari
  drawerInp.addEventListener('input', onTypeImmediate);
  drawerInp.addEventListener('input', onType);
  drawerInp.addEventListener('input', () => {
    if (clearBtn) clearBtn.hidden = !drawerInp.value;
  });

  // Enter -> arama sayfasina submit
  drawerInp.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const q = drawerInp.value.trim();
    if (!q) return;
    saveRecentSearch(q);
    window.location.href = '/search?q=' + encodeURIComponent(q);
  });

  if (backBtn) backBtn.addEventListener('click', () => efxClose());

  if (clearBtn) clearBtn.addEventListener('click', () => {
    drawerInp.value = '';
    clearBtn.hidden = true;
    onTypeImmediate({ target: drawerInp });
    onType({ target: drawerInp });
    drawerInp.focus({ preventScroll: true });
  });
})();

// RECENTS
function getRecentSearches() {
  try {
    const raw = localStorage.getItem(RECENT_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.filter(x => typeof x === "string" && x.trim()) : [];
  } catch { return []; }
}
function setRecentSearches(arr) {
  try { localStorage.setItem(RECENT_KEY, JSON.stringify(arr || [])); } catch {}
}
function saveRecentSearch(q) {
  const term = (q || "").trim();
  if (!term) return;
  const arr = [term, ...getRecentSearches().filter(x => x.toLowerCase() !== term.toLowerCase())]
          .slice(0, RECENT_MAX);
  setRecentSearches(arr);
}
function clearRecentSearches() {
  try { localStorage.removeItem(RECENT_KEY); } catch {}
}

/* Dışarıya açılan yüzey.
   Dosyanın geri kalanı IIFE içinde; tema tarafının ihtiyaç duyduğu tek şey
   bunlar:
   - efxOpen  : sections/mobile-category-drawer.liquid
   - efxSaveRecentSearch : layout/theme.liquid (/search sayfasına düşünce kaydeder)
   - efxClose / efxClearRecentSearches: kolaylık */
window.efxOpen  = efxOpen;
window.efxClose = efxClose;
window.efxSaveRecentSearch = saveRecentSearch;
window.efxClearRecentSearches = clearRecentSearches;

})();
